import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'je-page-not-found',
    templateUrl: './pagenotfound.container.html',
    imports: [FormsModule],
})
export class PageNotFoundContainerComponent {}
